import React, { Component } from 'react';
import { Container, Row, Col, Button, Table, Form, DropdownButton, Dropdown, Modal,OverlayTrigger, Tooltip,Image } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';

import NumberFormat from 'react-number-format';

import Connection from '../../../Calls';
import Backend from '../../../Backend';

import GAuth from '../../../Images/gauth.png'
import JsPdf from "jspdf";

import Contract from './contract';

var pricesSocket;

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

class InvoicesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentCoin:'',
      wallets:[],
      selectedWallet:'',
      renderCardPayment:'request',
      amountW:this.props.card_cost,
      passwordW:'',
      descriptionW: this.props.traductions.Card.payment.P_Description,
      selectedCurrency: 'usd',
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
      usdPrice:0,
      showContract:true
    }
  }

  componentWillMount(){
    this.getWallets();
    this.availableCoins();
  }

  componentWillUnmount(){
    if(pricesSocket){
      pricesSocket.close();
      pricesSocket = null;
    }
  }

  getWallets() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload

      Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), '', 1, 1000, payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            wallets: response.payload,
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
      Backend.InvoiceInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
        // console.log(response);
        if(response.status.code == 0){
          this.setState({
            address_pay:response.payload.address_pay
          })
        }
      });
    });

  }

  renderDropwdown(){
    var object = this.state.address_pay
    return this.state.wallets.map((item, i) => {
      // for (var coin in object) {
      //   if(item.coin === coin){
          return(
            <Dropdown.Item onClick={() => {this.selectWallet(item)}} as="button">
              <Image src={require("../../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
              {item.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(item.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{item.coin}</label>
            </Dropdown.Item>
          )
      //   }
      // }
    });
  }

  selectWallet(wallet){
    const self = this;

    this.state.availableCoinsArray.forEach((item, i) => {
      if(item.symbol == wallet.coin){
        this.setState({
          usdPrice: item.usd_price
        })
      }
    });
    this.setState({ selectedWallet: wallet, balanceWallet:wallet.balance, paymentCoin:wallet.coin })
  }

  sendCardPayment() {
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (this.state.amountW !== "" && this.state.passwordW !== "" && this.state.selectedWallet != '') {
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var charly = response.payload.r01;


        Backend.Check2FA(localStorage.getItem('email'),localStorage.getItem('token'), response.payload.r01, response => {
          if (response.status.code === "0") {
            if(response.payload.status == 'enabled'){
              this.setState({renderCardPayment:'2fa'})
            }else{
              this.sendCardPayment2FA()
            }
          }else{
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800000,
                onScreen: true
              }
            });
            self.setState({ showLoad: false });
          }
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({ showload: false });
    }
  }

  sendCardPayment2FA(){
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (this.state.amountW !== "" && this.state.passwordW !== "" && this.state.id_wallet != "") {
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var charly = response.payload.r01;

        var amountToSend = self.calculateCrypto()

        Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, response => {
          var code = this.state.digit1 + this.state.digit2 + this.state.digit3 + this.state.digit4 + this.state.digit5 + this.state.digit6
          Backend.WalletPayCard(localStorage.getItem('email'), localStorage.getItem('token'), this.state.selectedWallet.id_wallet, this.state.selectedWallet.coin, amountToSend, charly, response.payload.r03, code, response => {
            if (response.status.code === "0") {
              store.addNotification({
                title: "Success!",
                message: response.payload.message,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
              self.setState({
                amountW: '',
                tagIdW: '',
                descriptionW: '',
                showload: false,
                renderCardPayment:'request',
                digit1: '',
                digit2: '',
                digit3: '',
                digit4: '',
                digit5: '',
                digit6: '',
              });

              this.props.GetStatusCard()
            }else{

                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({
                  showload: false,
                  digit1: '',
                  digit2: '',
                  digit3: '',
                  digit4: '',
                  digit5: '',
                  digit6: '',
               });
            }
          })
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({
        showload: false,
        digit1: '',
        digit2: '',
        digit3: '',
        digit4: '',
        digit5: '',
        digit6: '',
        renderCardPayment:'request'
      });
    }
  }

  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.sendCardPayment2FA()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

  cancelWithdrawal(){
    this.setState({
      amountW: '',
      tagIdW: '',
      descriptionW: '',
      showload: false,
      renderCardPayment:'request',
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
     });
  }

  calculateCrypto(){
    var calculoCrypto = 0;
      var calculoCrypto = (this.state.amountW) / (this.state.usdPrice)
    return calculoCrypto
  }

  calculateUSD(){
    var calculoUsd;
      var calculoUsd = (this.state.amountW) * (this.state.usdPrice)
    return calculoUsd
  }

  availableCoins(){
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins( response => {
        this.setState({
          availableCoinsArray: response.payload
        })
      })

    });
  }

  renderCardPayment(){
    switch (this.state.renderCardPayment) {
      case 'request':
        return(
          <div className='payment-container'>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                <p className="title-container-shadow">{this.props.traductions.Card.payment.title}</p>
              </div>
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.Card.payment.L_Wallet}</Form.Label>
                <Col  sm="10" className="virtual_exchange_dropdown">
                  <DropdownButton className="invoices_dropdown"  style={{width:'100%'}}
                    title={
                      (this.state.selectedWallet)
                      ?<div>
                        <Image src={require("../../../CryptoIcons/" + this.state.selectedWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                        {this.state.selectedWallet.alias}
                      </div>
                      :this.props.traductions.Card.payment.P_Wallet
                    }>
                    {this.renderDropwdown()}
                  </DropdownButton>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.General.L_Amount}</Form.Label>
                  <Col sm="10">
                    <p className='text-available-modal'>{this.props.traductions.General.L_AmountAvl}: {(this.state.balanceWallet)?this.state.balanceWallet:Number(0).toFixed(2)} {this.state.paymentCoin}</p>
                    <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                      <NumberFormat  disabled className='btc-format-input' placeholder={this.props.traductions.General.P_Amount} decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amountW: value})}} />
                      {/* <Button disabled className={"boton-seleccionar-currency"} variant="link" >{this.state.paymentCoin.toUpperCase()}</Button> */}
                      <Button className={"boton-seleccionar-currency-selected"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                    </div>
                    <div className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error"}>
                      <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>{this.props.traductions.General.N_Amount3} {  (this.state.selectedWallet)?  Number(this.calculateCrypto()).toFixed(8):Number(0).toFixed(8)    } {this.state.paymentCoin}</p>
                    </div>
                  </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.Card.payment.L_Description}</Form.Label>
                <Col sm="10" className="virtual_exchange_dropdown">
                  <Form.Control type="text" placeholder={this.props.traductions.Card.payment.P_Description} value={this.state.descriptionW} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.Card.payment.L_pass}</Form.Label>
                <Col sm="10" className="virtual_exchange_dropdown">
                  <Form.Control type="password" placeholder={this.props.traductions.Card.payment.P_pass} value={this.state.passwordW} onChange={(passwordW) => { this.setState({ passwordW: passwordW.target.value }) }} />
                </Col>
              </Form.Group>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button onClick={() => { this.sendCardPayment() }} className="signup-button" variant="primary" disabled={this.state.showLoad}>

                {
                  (this.state.showload)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                  : this.props.traductions.Card.payment.btn
                }
              </Button>
            </div>
          </div>
        )
        break;
      case '2fa':
        return(
          <div>
            <div className="border-title-separator-container-left" style={{ width: "100%" }}>
              <p className="title-container-shadow">{this.props.traductions.General.TwoFa.title}</p>
            </div>
            <div className='activate-2fa-titles'>
              <div className='gauth_logo inline-block'>
                <Image src={GAuth}/>
              </div>
              <div className='inline-block'>
                <p className='password-notice'>{this.props.traductions.General.TwoFa.desc}</p>
              </div>
            </div>
            <div style={{ marginTop: 25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Container className="container-google-autenticathor">
                <Row>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref1'
                      ref='digit_ref1'
                      maxlength='1'
                      value={this.state.digit1}
                      onChange={(digit1) => {this._handleChange(1,digit1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref2'
                      ref='digit_ref2'
                      maxlength='1'
                      value={this.state.digit2}
                      onChange={(digit2)=> {this._handleChange(2,digit2)}}
                      onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref3'
                      ref='digit_ref3'
                      maxlength='1'
                      value={this.state.digit3}
                      onChange={(digit3) => {this._handleChange(3,digit3)}}
                      onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref4'
                      ref='digit_ref4'
                      maxlength='1'
                      value={this.state.digit4}
                      onChange={(digit4) => {this._handleChange(4,digit4)}}
                      onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref5'
                      ref='digit_ref5'
                      maxlength='1'
                      value={this.state.digit5}
                      onChange={(digit5) => { this._handleChange(5,digit5)}}
                      onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref6'
                      ref='digit_ref6'
                      maxlength='1'
                      value={this.state.digit6}
                      onChange={(digit6) => { this._handleChange(6,digit6)}}
                      onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button className="virtual_exchange_information_wallets_text-link" variant="link" onClick={() => this.cancelWithdrawal()}>{this.props.traductions.General.TwoFa.cancel}</Button>
            </div>
          </div>
        )
        break;
    }
  }

  render() {
    return (
      <div className="contenedor-wallets-generals">
        <div className='container-withouth-data-wallets'>
          {this.renderCardPayment()}
          <div>
            {/* <Contract show={this.state.showContract} handleClose={()=>this.setState({showContract:false})}/> */}
          </div>
        </div>
      </div>
    );
  }
}

export default InvoicesIndex;
